import axios from "axios";
const jsonConfig = require("../../Config.json");

const getSubSkillsResponse = async () => {
    let allSkillsList = {}
    try {
        const getallskillresponse = await axios.get(
            jsonConfig.apiUrl + "subSkills",
            {
                headers: {
                    "x-functions-key": jsonConfig.key,
                },
            });
        allSkillsList = getallskillresponse;

        return Promise.resolve(allSkillsList)
    }
    catch (error) {
        //    console.error(error);
        return Promise.reject(error)
    }
}

export default getSubSkillsResponse;